import { useMutation } from '@tanstack/react-query';
import { updateLineItemQuantity as clientUpdateLineItemQuantity } from 'typescript/clients/solidshop/cart_client';
import { captureException } from '@sentry/react';
import { CustomError } from 'typescript/utilities/custom_error';
import { MUTATION_KEYS } from 'typescript/constants/react_query';

export const useUpdateLineItemQuantity = () => {
  const { mutate: updateLineItemQuantity, ...rest } = useMutation({
    mutationKey: [MUTATION_KEYS.UPDATE_LINE_ITEM_QUANTITY],
    mutationFn: clientUpdateLineItemQuantity,
    onError: (error) => {
      captureException(
        new CustomError(MUTATION_KEYS.UPDATE_LINE_ITEM_QUANTITY, error),
      );
    },
  });

  return { updateLineItemQuantity, ...rest };
};
